const RowColIcon = ({ width = 16, height = 14, rowOrCol = "row" }) => {
  const color = "#af7eff"

  if (rowOrCol === "row") {
    return (
      <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} fill={color}>
        <rect x="0" y="8" width={width} height="2" />
        <rect x="0" y="12" width={width} height="2" />

        <path
          d={`
            M 0 4
            H ${width - 8}
            V 0
            L ${width} 6
            L ${width - 8} 12
            V 8
            H 0
            Z
          `}
        />
      </svg>
    )
  }

  return (
    <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} fill={color}>
      <rect x="2" y="0" width="2.5" height={height} />
      <rect x="6.5" y="0" width="2.5" height={height} />

      <path
        d={`
          M 11 0
          V ${height}
          L 16 ${height - 6}
          H 13
          V 0
          Z
        `}
      />
    </svg>
  )
}

const PieIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24">
      <path d="M 12 12 L 21.66 6.82 A 10 10 0 0 0 12 2 Z" fill="#F44336" />
      <path d="M 12 12 L 12 2 A 10 10 0 0 0 2.46 15.09 Z" fill="#FFC107" />
      <path d="M 12 12 L 2.46 15.09 A 10 10 0 0 0 21.66 6.82 Z" fill="#2196F3" />
    </svg>
  )
}

const BarIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24">
      <rect x="4" y="10" width="4" height="10" fill="#F44336" />
      <rect x="10" y="3" width="4" height="17" fill="#FFC107" />
      <rect x="16" y="6" width="4" height="14" fill="#2196F3" />
    </svg>
  )
}

const BarIconHorizontal = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24">
      <rect x="3" y="3" width="10" height="4" fill="#F44336" />
      <rect x="3" y="10" width="17" height="4" fill="#FFC107" />
      <rect x="3" y="17" width="14" height="4" fill="#2196F3" />
    </svg>
  )
}

const DoughnutIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path d="M 12 4 A 8 8 0 0 1 18.93 8" stroke="#F44336" strokeWidth="4" strokeLinecap="butt" />

      <path
        d="M 18.93 8 A 8 8 0 0 1 4.28 17.14"
        stroke="#FFC107"
        strokeWidth="4"
        strokeLinecap="butt"
      />

      <path
        d="M 4.28 17.14 A 8 8 0 0 1 12 4"
        stroke="#2196F3"
        strokeWidth="4"
        strokeLinecap="butt"
      />
    </svg>
  )
}

const LineIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path d="M 2 16 Q 8 4 12 12 Q 16 20 22 8" stroke="#F44336" strokeWidth="2" fill="none" />

      <circle cx="2" cy="16" r="1" fill="#FFC107" />
      <circle cx="12" cy="12" r="1" fill="#FFC107" />
      <circle cx="22" cy="8" r="1" fill="#FFC107" />
    </svg>
  )
}

const BoxplotIcon = () => {
  const color = "#af7eff"

  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
      <line x1="12" y1="2" x2="12" y2="22" stroke={color} strokeWidth="2" />
      <line x1="7" y1="2" x2="17" y2="2" stroke={color} strokeWidth="2" />
      <line x1="7" y1="22" x2="17" y2="22" stroke={color} strokeWidth="2" />

      <rect
        x="7"
        y="10"
        width="10"
        height="8"
        fill={color}
        fillOpacity="0.25"
        stroke={color}
        strokeWidth="2"
      />

      <line x1="7" y1="14" x2="17" y2="14" stroke={color} strokeWidth="2" />
    </svg>
  )
}

export { RowColIcon, PieIcon, BarIcon, BarIconHorizontal, DoughnutIcon, LineIcon, BoxplotIcon }
